export default __webpack_public_path__ + "static/media/prize_icon.90c3c60d.svg";